import { metricNames, SettingValues } from '@linearb/linjs-common';
import Text from 'components/base/Text';
import { Tooltip } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import {
  StyledCycleTimeCell,
  StyledTitle,
  StyledMetricsBenchmarkIcon,
  StyledBlankTrendIcon
} from './Cells.style';
import MetricsBenchmarkIcon from 'components/MetricsBenchmarkIcon';
import { CycleTimePopupTooltip } from 'components/Tooltips/CycleTimeTooltip';
import useMetricsCalculationConfig from 'views/root/views/home/hooks/useMetricsCalculationConfig';
import useBenchmarkOrgSizeConfig from 'views/root/views/home/hooks/useBenchmarkOrgSizeConfig';
import useSettingsService from 'components/hooks/useSettingsService';
import { getCycleTimeConfigurations } from 'views/root/views/home/views/dashboard/dashboard.service';
import { mapCycleTimeStatisticsToPipelineMilestones } from 'components/DeliveryPipeline';
import Icon from 'components/base/Icon';
import CellTooltip from './CellToolTip';
import { getShouldShowTrend } from '../../../GroupMetricsTable.service';
import { getIsBenchmarkPending } from 'views/root/views/home/views/dashboard/components/CycleTime/CycleTime.utils';

const CycleTimeCell = ({
  value,
  previuosValue,
  valueFormatted,
  previuosValueFormatted,
  mappedV3Data,
  selectedTeamId,
  isHovered = false,
  trendIconName,
  trendIconColor = 'catskillWhite',
  trendDirection = '',
  tooltipTitle,
  percentChange,
  lastPeriodDates
}) => {
  const metricsCalculationConfig = useMetricsCalculationConfig();
  const { benchmarkOrgSize } = useBenchmarkOrgSizeConfig();
  const { getSettingOrDefinitionValue } = useSettingsService();
  const isHideNonWorkingDaysEnabled = getSettingOrDefinitionValue(
    { name: SettingValues.HIDE_NON_WORKING_DAYS },
    false
  );
  const benchmarkIconSize = 'medium';

  const shouldShowTrend = getShouldShowTrend(
    valueFormatted,
    trendIconName,
    previuosValueFormatted,
    lastPeriodDates
  );

  const configurations = getCycleTimeConfigurations(
    mapCycleTimeStatisticsToPipelineMilestones(
      mappedV3Data,
      {},
      metricsCalculationConfig,
      benchmarkOrgSize
    ),
    true
  );

  const isBenchmarkPending = getIsBenchmarkPending({ configurations });

  return (
    <Flex>
      <StyledCycleTimeCell items='center'>
        <CycleTimePopupTooltip
          scale={0.9}
          metricsCalculationConfig={metricsCalculationConfig}
          totalTime={valueFormatted}
          title={
            <Flex items='center'>
              <StyledTitle>Cycle time breakdown</StyledTitle>
            </Flex>
          }
          configurations={configurations}
          isHideNonWorkingDaysEnabled={isHideNonWorkingDaysEnabled}
        >
          <Text size='medium' color='shuttleGray'>
            {valueFormatted}
          </Text>
        </CycleTimePopupTooltip>

        <StyledMetricsBenchmarkIcon size={benchmarkIconSize}>
          {!isBenchmarkPending && (
            <MetricsBenchmarkIcon
              value={value}
              metricName={metricNames.CYCLE_TIME}
              size={benchmarkIconSize}
              margin='0.3rem 0 0 0.7rem'
              selectedTeamId={selectedTeamId}
              isDisableHoverListener={true}
            />
          )}
        </StyledMetricsBenchmarkIcon>
      </StyledCycleTimeCell>
      {shouldShowTrend ? (
        <Tooltip
          title={
            <CellTooltip
              title={tooltipTitle}
              directionColor={trendIconColor}
              previuosValueFormatted={previuosValueFormatted}
              trendDirection={trendDirection}
              percentChange={percentChange}
              lastPeriodDates={lastPeriodDates}
              {...(!isBenchmarkPending && {
                PreviuosBenchmark: () => (
                  <MetricsBenchmarkIcon
                    value={previuosValue}
                    metricName={metricNames.CYCLE_TIME}
                    size={benchmarkIconSize}
                    margin='0.3rem 0 0 0.7rem'
                    selectedTeamId={selectedTeamId}
                    isDisableHoverListener={true}
                  />
                )
              })}
            />
          }
        >
          <Flex items='center' pl='1.5rem'>
            <Icon name={trendIconName} color={trendIconColor} />
          </Flex>
        </Tooltip>
      ) : (
        <StyledBlankTrendIcon />
      )}
    </Flex>
  );
};
export default CycleTimeCell;
